export default __webpack_public_path__ + "atomic/_patterns/02-molecules/view-style-list/_view-style-list.twig";